import { ActionKeys } from '~/actions/constants';

export const openCreditCardModal = () =>
  <const>{
    type: ActionKeys.BILLING_OPEN_CREDIT_CARD_MODAL,
  };

export const closeCreditCardModal = () =>
  <const>{
    type: ActionKeys.BILLING_CLOSE_CREDIT_CARD_MODAL,
  };

export type BillingActions =
  | ReturnType<typeof closeCreditCardModal>
  | ReturnType<typeof openCreditCardModal>;
